/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description React Hook useUserAttributes
 */
import _ from 'lodash';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

import api from 'client/index';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * Get user attributes
 */
const getUserAttributes = (key: string, data?: AnyRecord): IColumnMeta[] => {
	const attributes = _.first(_.get(data, key, []) as string[]);
	return attributes ? JSON.parse(attributes) : [];
};

/**
 * Use UserAttributes hook
 * @returns {UseQueryResult} useUserAttributes
 */
const useUserAttributes = (userId: string): UseQueryResult<AnyRecord, IAxiosError> => {
	return useQuery({
		queryKey: [QUERY_KEYS.userAttributes, { id: userId }],
		queryFn: async () => {
			const { data } = await api.KeycloakUserApi.getUserAttributes({ id: userId });
			return data;
		},
		enabled: !!userId,
		refetchOnMount: false,
		refetchInterval: 1000 * 60 * 10, // 10 minutes
	});
};

export { getUserAttributes };
export default useUserAttributes;
